import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('agreements', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`agreements/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('agreements', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        requisition: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('notes', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.put(`allocate_tickets/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        sale: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`sales/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        effectiveDate: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('effective_date', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`agreements/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        buyers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('buyers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        markets: (cntx, params) => {
            console.log(params)
            return new Promise((resolve, reject) => {
                axios.get('markets', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        sales: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        grades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('grades', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        growers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('growers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        registrationNumbers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('registration_numbers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        documents: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('documents', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        createPrint: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('sale_documents', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        showSale: (cntx, id) => {
            // console.log(id)
            axios.get(`sales/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        tickets: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('tickets_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
